export default __webpack_public_path__ + "static/media/main-img1.18666618.webp";